/* Maison Lumelle — motion engine (ported from design prototype) */
(function () {
  'use strict';
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var cleanup = [];
  var annInt = null, revInt = null, raf = null, craf = null, mo = null;

  function q(s, el) { return (el || document).querySelector(s); }
  function qa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function on(target, ev, fn, opts) { target.addEventListener(ev, fn, opts); cleanup.push(function () { target.removeEventListener(ev, fn, opts); }); }

  function teardown() {
    cleanup.forEach(function (fn) { fn(); });
    cleanup = [];
    if (annInt) { clearInterval(annInt); annInt = null; }
    if (revInt) { clearInterval(revInt); revInt = null; }
    if (raf) { cancelAnimationFrame(raf); raf = null; }
    if (craf) { cancelAnimationFrame(craf); craf = null; }
    if (mo) { cancelAnimationFrame(mo); mo = null; }
    var d = q('.lumelle-cursor');
    if (d) d.parentNode.removeChild(d);
  }

  function init() {
    teardown();
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* 1 - Announcement rotation */
    var aTrack = q('.lumelle-announce-track');
    if (aTrack && !reduced && aTrack.children.length > 1) {
      var count = aTrack.children.length;
      var itv = parseInt(aTrack.getAttribute('data-interval') || '3800', 10);
      var ai = 0;
      annInt = setInterval(function () {
        ai = (ai + 1) % count;
        aTrack.style.transform = 'translateY(-' + (ai * 40) + 'px)';
      }, itv);
    }

    /* 2 - Compact sticky header (viewport-relative: show once the main header scrolls off the top) */
    var compact = q('.lumelle-header-compact');
    var headerEl = q('.lumelle-header');
    var onScr = function () {
      if (!compact || !headerEl) return;
      var show = headerEl.getBoundingClientRect().bottom <= 0;
      compact.style.transform = show ? 'translateY(0)' : 'translateY(-110%)';
    };
    on(window, 'scroll', onScr, { passive: true });
    on(window, 'resize', onScr);
    onScr();

    /* Burger / mobile nav */
    var panel = q('.lumelle-mobnav');
    if (panel) {
      qa('.lumelle-burger').forEach(function (b) { on(b, 'click', function () { panel.style.transform = 'translateX(0)'; }); });
      qa('.lumelle-mobnav-close, .lumelle-mobnav a').forEach(function (el) { on(el, 'click', function () { panel.style.transform = 'translateX(-102%)'; }); });
    }

    /* Scroll reveals */
    var vh = window.innerHeight;
    var revealMap = new Map();
    var setup = function (el) {
      var type = el.getAttribute('data-reveal');
      var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
      if (reduced) return null;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.85) return null;
      if (type === 'curtain') {
        var c = q('.lumelle-curtain', el);
        var z = q('.lumelle-zoomin', el);
        if (c) { c.style.transition = 'none'; c.style.transform = 'translateX(0)'; }
        if (z) { z.style.transition = 'none'; z.style.transform = 'scale(1.06)'; }
        return function () {
          requestAnimationFrame(function () {
            if (c) { c.style.transition = 'transform 900ms ' + EASE + ' ' + delay + 'ms'; c.style.transform = 'translateX(101%)'; }
            if (z) { z.style.transition = 'transform 1100ms ' + EASE + ' ' + delay + 'ms'; z.style.transform = 'scale(1)'; }
          });
        };
      }
      if (type === 'lines') {
        var lines = qa('[data-line]', el);
        lines.forEach(function (l) { l.style.transition = 'none'; l.style.transform = 'translateY(115%)'; });
        return function () {
          requestAnimationFrame(function () {
            lines.forEach(function (l, i) {
              l.style.transition = 'transform 900ms ' + EASE + ' ' + (delay + i * 80) + 'ms';
              l.style.transform = 'translateY(0)';
            });
          });
        };
      }
      if (type === 'fade') {
        el.style.transition = 'none'; el.style.opacity = '0'; el.style.transform = 'translateY(22px)';
        return function () {
          requestAnimationFrame(function () {
            el.style.transition = 'opacity 900ms ' + EASE + ' ' + delay + 'ms, transform 900ms ' + EASE + ' ' + delay + 'ms';
            el.style.opacity = '1'; el.style.transform = 'translateY(0)';
          });
        };
      }
      if (type === 'stamp') {
        el.style.transition = 'none'; el.style.opacity = '0'; el.style.transform = 'scale(1.15) rotate(2deg)';
        return function () {
          requestAnimationFrame(function () {
            el.style.transition = 'opacity 600ms ' + EASE + ', transform 900ms ' + EASE;
            el.style.opacity = '1'; el.style.transform = 'scale(1) rotate(0deg)';
          });
        };
      }
      if (type === 'frame') {
        var flines = qa('.lumelle-frameline', el);
        var kids = qa('.lumelle-framefade', el);
        flines.forEach(function (l) {
          l.style.transition = 'none';
          l.style.transform = l.getAttribute('data-axis') === 'y' ? 'scaleY(0)' : 'scaleX(0)';
        });
        kids.forEach(function (k) { k.style.transition = 'none'; k.style.opacity = '0'; });
        return function () {
          requestAnimationFrame(function () {
            flines.forEach(function (l, i) {
              l.style.transition = 'transform 900ms ' + EASE + ' ' + (i * 100) + 'ms';
              l.style.transform = 'scale(1)';
            });
            kids.forEach(function (k, i) {
              k.style.transition = 'opacity 800ms ' + EASE + ' ' + (350 + i * 90) + 'ms';
              k.style.opacity = '1';
            });
          });
        };
      }
      return null;
    };
    qa('[data-reveal]').forEach(function (el) {
      var fn = setup(el);
      if (fn) revealMap.set(el, fn);
    });
    var checkReveals = function () {
      if (!revealMap.size) return;
      var vhh = window.innerHeight;
      revealMap.forEach(function (fn, el) {
        var r = el.getBoundingClientRect();
        if (r.top < vhh * 0.92) { revealMap.delete(el); fn(); }
      });
    };
    on(window, 'scroll', checkReveals, { passive: true });
    on(window, 'resize', checkReveals);
    revInt = setInterval(checkReveals, 600);
    setTimeout(checkReveals, 150);

    /* 4 - Par piece hover-index */
    var idxImgs = qa('.lumelle-idx-img');
    qa('.lumelle-idx-item').forEach(function (item) {
      on(item, 'mouseenter', function () {
        var t = item.getAttribute('data-idx');
        idxImgs.forEach(function (im) { im.style.opacity = im.getAttribute('data-idx') === t ? '1' : '0'; });
        qa('.lumelle-idx-item').forEach(function (other) {
          var active = other === item;
          var num = q('.lumelle-idx-num', other);
          var name = q('.lumelle-idx-name', other);
          if (num) num.style.color = active ? '#A98B4F' : '#6B645C';
          if (name) name.style.transform = active ? 'translateX(10px)' : 'translateX(0)';
        });
      });
    });

    /* 5 - L'Edit carousel */
    var track = q('.lumelle-edit-track');
    if (track) {
      var odo = q('.lumelle-odo');
      var cards = qa('.lumelle-edit-card', track);
      var step = function () {
        var card = cards[0];
        return card ? card.offsetWidth + 40 : 340;
      };
      var updateOdo = function () {
        if (!odo) return;
        var idx = Math.min(Math.max(cards.length - 1, 0), Math.max(0, Math.round(track.scrollLeft / step())));
        odo.style.transform = 'translateY(-' + (idx * 22) + 'px)';
      };
      on(track, 'scroll', function () { requestAnimationFrame(updateOdo); }, { passive: true });
      var prev = q('.lumelle-arrow-prev');
      var next = q('.lumelle-arrow-next');
      if (prev) on(prev, 'click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (next) on(next, 'click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
      var down = false, startX = 0, startL = 0, lastX = 0, vel = 0, moved = 0;
      on(track, 'mousedown', function (e) {
        down = true; moved = 0; startX = e.pageX; startL = track.scrollLeft; lastX = e.pageX; vel = 0;
        if (mo) cancelAnimationFrame(mo);
        track.style.cursor = 'grabbing';
      });
      on(window, 'mousemove', function (e) {
        if (!down) return;
        var dx = e.pageX - startX;
        moved = Math.max(moved, Math.abs(dx));
        vel = lastX - e.pageX; lastX = e.pageX;
        track.scrollLeft = startL - dx;
        if (moved > 6) e.preventDefault();
      });
      on(window, 'mouseup', function () {
        if (!down) return;
        down = false;
        track.style.cursor = 'grab';
        if (reduced) return;
        var momentum = function () {
          if (Math.abs(vel) < 0.4) return;
          track.scrollLeft += vel;
          vel *= 0.94;
          mo = requestAnimationFrame(momentum);
        };
        momentum();
      });
      on(track, 'click', function (e) { if (moved > 8) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    }

    /* Hover crossfade + zoom */
    qa('.lumelle-cross').forEach(function (card) {
      var back = q('.lumelle-cross-back', card);
      var zoom = q('.lumelle-zoomin', card);
      on(card, 'mouseenter', function () {
        if (back) back.style.opacity = '1';
        if (zoom) { zoom.style.transition = 'transform 700ms ' + EASE; zoom.style.transform = 'scale(1.03)'; }
      });
      on(card, 'mouseleave', function () {
        if (back) back.style.opacity = '0';
        if (zoom) zoom.style.transform = 'scale(1)';
      });
    });
    qa('[data-cursor="voir"]').forEach(function (el) {
      if (el.classList.contains('lumelle-cross')) return;
      var zoom = q('.lumelle-zoomin', el);
      if (!zoom) return;
      on(el, 'mouseenter', function () { zoom.style.transition = 'transform 700ms ' + EASE; zoom.style.transform = 'scale(1.03)'; });
      on(el, 'mouseleave', function () { zoom.style.transform = 'scale(1)'; });
    });

    /* 8 - Marquee + parallax */
    var mq = q('.lumelle-marquee-track');
    var mqSection = q('.lumelle-chezvous');
    var mqHover = false;
    if (mqSection) {
      on(mqSection, 'mouseenter', function () { mqHover = true; });
      on(mqSection, 'mouseleave', function () { mqHover = false; });
    }
    var mx = 0, msp = 0;
    var pEls = qa('[data-parallax]');
    var tick = function () {
      checkReveals();
      if (mq) {
        var base = parseFloat(mq.getAttribute('data-speed') || '0.55');
        var target = mqHover ? base * 0.22 : base;
        msp += (target - msp) * 0.05;
        mx -= msp;
        var gw = mq.scrollWidth / 2;
        if (gw > 0 && -mx >= gw) mx += gw;
        mq.style.transform = 'translateX(' + mx.toFixed(2) + 'px)';
      }
      var vhh = window.innerHeight;
      pEls.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-parallax'));
        var parent = el.parentElement;
        if (!parent) return;
        var r = parent.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vhh + 100) return;
        var c = r.top + r.height / 2 - vhh / 2;
        var extra = el.style.getPropertyValue('--lm-base') || '';
        el.style.transform = 'translateY(' + (c * -f).toFixed(1) + 'px)' + (extra ? ' ' + extra : '');
      });
      raf = requestAnimationFrame(tick);
    };
    if (!reduced) raf = requestAnimationFrame(tick);

    /* Custom cursor (desktop only) */
    var fine = window.matchMedia('(pointer: fine)').matches;
    if (fine && !reduced) {
      var dot = document.createElement('div');
      dot.className = 'lumelle-cursor';
      dot.setAttribute('aria-hidden', 'true');
      dot.style.cssText = 'display:flex;position:fixed;left:-100px;top:-100px;z-index:999;width:10px;height:10px;border-radius:50%;background:#A98B4F;align-items:center;justify-content:center;pointer-events:none;transition:width 400ms ' + EASE + ',height 400ms ' + EASE + ';';
      var lbl = document.createElement('span');
      lbl.className = 'lumelle-cursor-label';
      lbl.style.cssText = 'opacity:0;font-size:10px;font-weight:500;letter-spacing:0.1em;text-transform:uppercase;color:#FAF7F2;transition:opacity 400ms ' + EASE + ';';
      lbl.textContent = 'Voir';
      dot.appendChild(lbl);
      document.body.appendChild(dot);
      var cx = -100, cy = -100, tx = -100, ty = -100;
      on(window, 'mousemove', function (e) { tx = e.clientX; ty = e.clientY; });
      var cursorTick = function () {
        cx += (tx - cx) * 0.22;
        cy += (ty - cy) * 0.22;
        dot.style.left = cx.toFixed(1) + 'px';
        dot.style.top = cy.toFixed(1) + 'px';
        dot.style.marginLeft = -(dot.offsetWidth / 2) + 'px';
        dot.style.marginTop = -(dot.offsetHeight / 2) + 'px';
        craf = requestAnimationFrame(cursorTick);
      };
      craf = requestAnimationFrame(cursorTick);
      qa('[data-cursor="voir"]').forEach(function (el) {
        on(el, 'mouseenter', function () {
          el.style.cursor = 'none';
          dot.style.width = '58px'; dot.style.height = '58px';
          lbl.style.opacity = '1';
        });
        on(el, 'mouseleave', function () {
          dot.style.width = '10px'; dot.style.height = '10px';
          lbl.style.opacity = '0';
        });
      });
    }

    /* Defiler cue */
    var cue = q('.lumelle-cue');
    var pieces = q('.lumelle-pieces');
    if (cue && pieces) {
      on(cue, 'click', function () {
        window.scrollTo({ top: pieces.getBoundingClientRect().top + window.scrollY - 70, behavior: reduced ? 'auto' : 'smooth' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 60); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 60); });
  document.addEventListener('shopify:section:reorder', function () { setTimeout(init, 60); });
})();
